'use client';

import { createContext, useContext, PropsWithChildren } from 'react';
import useRoadshowsTile from './useRoadshowsTile';
import { IRoadshowResponse } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsResponse';
import { IRoadshowsFilters } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsPayload';

type RoadshowsTileContextType = ReturnType<typeof useRoadshowsTile>;

const RoadshowsTileContext = createContext<RoadshowsTileContextType | null>(null);

export const useRoadshowsTileContext = () => {
  const context = useContext(RoadshowsTileContext);

  if (!context) {
    throw new Error('useRoadshowsTileContext must be used within a RoadshowsTileProvider');
  }

  return context;
};

interface IProps extends PropsWithChildren {
  totalCount: number,
  collection: IRoadshowResponse[],
  filters: IRoadshowsFilters,
  hasServerError?: boolean,
}

const RoadshowsTileProvider = ({ children, ...props }: IProps) => (
  <RoadshowsTileContext.Provider value={ useRoadshowsTile(props) }>
    { children }
  </RoadshowsTileContext.Provider>
);

export default RoadshowsTileProvider;
